import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { HowItWorks } from './components/HowItWorks';
import { Footer } from './components/Footer';
import { RegistrationModal } from './components/RegistrationModal';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CookiesPage } from './pages/CookiesPage';
function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brand-100 selection:text-brand-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero openModal={() => setIsModalOpen(true)} data-id="element-3" />
        <Features data-id="element-4" />
        <HowItWorks openModal={() => setIsModalOpen(true)} data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
      <RegistrationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-7" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<LandingPage data-id="element-11" />} data-id="element-10" />
        <Route path="/terms" element={<TermsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-15" />} data-id="element-14" />
        <Route path="/cookies" element={<CookiesPage data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}